import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Document, WorkflowStep } from '../../store/models';
import { Dataset } from '../../store/models/dataset.model';

@Injectable({ providedIn: 'root' })
export class WorkflowTransitionService {
  transitionCancelled$: Subject<TransitionWorkflowCancelledEvent> = new Subject();
  transitionWorkflowWithForm$: Subject<TransitionWorkflowEvent> = new Subject();
  transitionWorkflow$: Subject<TransitionWorkflowEvent> = new Subject();

  showFormAndTransitionWorkflow(event: TransitionWorkflowEvent) {
    this.transitionWorkflowWithForm$.next(event);
  }

  transitionWorkflow(event: TransitionWorkflowEvent) {
    this.transitionWorkflow$.next(event);
  }

  cancelTransitionWorkflow(event: TransitionWorkflowEvent) {
    this.transitionCancelled$.next(event);
  }
}

export interface TransitionWorkflowEvent {
  dataset: Dataset;
  document: Document;
  previousStep: WorkflowStep;
  nextStep: WorkflowStep;
  transitionViewUId?: string;
}

export interface TransitionWorkflowCancelledEvent {
  dataset: Dataset;
  document: Document;
  previousStep: WorkflowStep;
}
